module.exports = __webpack_public_path__ + "static/media/English_Indian_Sharmila BG-01.e7caf7c4.png";